import React, { useState, useEffect } from 'react';
import image1 from '../assets/image-carousel-1.jpg';
import image2 from '../assets/image-carousel-2.jpg';
import image3 from '../assets/image-carousel-3.jpg';
import image4 from '../assets/image-carousel-4.jpg';
import image5 from '../assets/image-carousel-5.jpg';

const ImageCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    {
      src: image1,
      altText: 'Carousel Image 1',
    },
    {
      src: image2,
      altText: 'Carousel Image 2',
    },
    {
      src: image3,
      altText: 'Carousel Image 3',
    },
    {
      src: image4,
      altText: 'Carousel Image 4',
    },
    {
      src: image5,
      altText: 'Carousel Image 5',
    },
  ];

  const next = () => {
    setActiveIndex((prevIndex) => (prevIndex === items.length - 1 ? 0 : prevIndex + 1));
  };

  const previous = () => {
    setActiveIndex((prevIndex) => (prevIndex === 0 ? items.length - 1 : prevIndex - 1));
  };

  const goToIndex = (newIndex) => {
    setActiveIndex(newIndex);
  };

  // Auto-rotate carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex === items.length - 1 ? 0 : prevIndex + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [items.length]);

  const carouselStyles = {
    carousel: {
      position: 'relative',
      width: '100%',
      margin: '0 auto',
      overflow: 'hidden',
      zIndex: 1,
    },
    carouselInner: {
      position: 'relative',
      width: '100%',
      height: '600px',
      overflow: 'hidden',
    },
    carouselItem: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      transition: 'opacity 0.6s ease-in-out',
    },
    carouselItemActive: {
      opacity: 1,
      zIndex: 1,
    },
    carouselImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    carouselControl: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      color: '#fff',
      border: 'none',
      padding: '10px 15px',
      cursor: 'pointer',
      fontSize: '18px',
      zIndex: 2,
      transition: 'background-color 0.3s ease',
    },
    carouselControlPrev: {
      left: '10px',
    },
    carouselControlNext: {
      right: '10px',
    },
    carouselControlHover: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    carouselIndicators: {
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '10px',
      zIndex: 2,
    },
    indicator: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      padding: 0,
    },
    indicatorActive: {
      backgroundColor: '#fff',
    },
  };

  return (
    <div style={carouselStyles.carousel}>
      <div style={carouselStyles.carouselInner}>
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              ...carouselStyles.carouselItem,
              ...(index === activeIndex ? carouselStyles.carouselItemActive : {}),
            }}
          >
            <img
              src={item.src}
              alt={item.altText}
              style={carouselStyles.carouselImage}
            />
          </div>
        ))}
      </div>

      <button
        style={carouselStyles.carouselControl}
        onClick={previous}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = carouselStyles.carouselControlHover.backgroundColor;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        }}
        aria-label="Previous"
      >
        ‹
      </button>

      <button
        style={{
          ...carouselStyles.carouselControl,
          ...carouselStyles.carouselControlNext,
        }}
        onClick={next}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = carouselStyles.carouselControlHover.backgroundColor;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        }}
        aria-label="Next"
      >
        ›
      </button>

      <div style={carouselStyles.carouselIndicators}>
        {items.map((item, index) => (
          <button
            key={index}
            style={{
              ...carouselStyles.indicator,
              ...(index === activeIndex ? carouselStyles.indicatorActive : {}),
            }}
            onClick={() => goToIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;

